/*const appex_analytics_v5_keys = [
  'listing', 18 characters external lisiting id
  'token', user_token
  'date', '2021-09-23T12:59:28.485Z' generated from timestamp value
  'timestamp', at event generation
  'channel', generated at cleaner based on url , referrer and event belonging to featured or recomended section
             Values: AppExchange Sponsored Search, AppExchange Featured, AppExchange Recommended,
             AppExchange Search, AppExchange Categories, Google, Facebook, Web, AppExchange Browse
  'parent_channel', depends on channel value
  'topic', at event generation, some of the values are used at the cleaner to identify event_type
  and at the rollup to identify
            Values:
                'analytics_user_activity', send along click on buttons or links like, watch demo, Test drive, getitNow,
                                           resources view, identify event_type, used at rollup queries
                'analytics_user_install'
                'analytics_lead_event'
                'analytics_click'
                'analytics_hover'
                'analytics_load_impression'
                'analytics_shown_impression'
                'analytics_load_search_results'
                'analytics_page_load'
                'analytics_search_done'
                'analytics_tile_open'
                'analytics_user_install'
                'analytics_carousel_shown_impression'
                'analytics_user_activity'
                'analytics_chat_init'
  'event_type',
  'url',
  'browser',
  'country',
  'state',
  'authenticated',
  'element',
  'keyword',
  'language',
  'carousel_position',
  'media_type',
  'mouse_x',
  'mouse_y',
  'object_identifier',
  'object_type',
  'page_listing',
  'referrer',
  'primary_key',
  'schema_version',
  'device_height',
  'device_width',
  'viewport_height',
  'viewport_width',
  'record_key',
  'jailed',
  'campaign_name',
  'campaign_start_date',
  'campaign_end_date',
  'placement_id',
  'trace',
];*/

import { v4 as uuidv4 } from 'uuid';
import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { PUBLIC_URL } from '~/modules/config';
import { CoveoAnalyticsTarget } from '../analytics/coveoAnalyticsTarget';
import { GoogleTagManager } from '../analytics/googleTagManager';
import { MarketingAnalytics } from '../analytics/marketingAnalytics';
import { routerStore } from '../stores/routerStore';
import { selectUserToken, userStore } from '../stores/userStore';
import { logger } from '../utilities/logger';

type AnalyticsContext = {
    viewport_height: number;
    viewport_width: number;
    device_height: number;
    device_width: number;
    browser: string;
    language: string;
    url: string;
    referrer?: string;
    authenticated: boolean;
    token: string;
    channel: string;
    parent_channel: string;
    schema_version: string;
};

type EventTopic =
    | AnalyticsEventTopic.ANALYTICS_CLICK
    | 'analytics_hover'
    | AnalyticsEventTopic.ANALYTICS_LOAD_IMPRESSION
    | AnalyticsEventTopic.ANALYTICS_SHOWN_IMPRESSION
    | AnalyticsEventTopic.ANALYTICS_PAGE_LOAD
    | AnalyticsEventTopic.ANALYTICS_AUTHENTICATION
    | AnalyticsEventTopic.EXPERIMENT_IMPRESSION
    | AnalyticsEventTopic.ANALYTICS_CHAT_INIT
    | AnalyticsEventTopic.ANALYTICS_SEARCH_DONE;

export interface AnalyticsEvent extends AnalyticsContext {
    topic: EventTopic;
    listingId?: string;
    page_listing?: string;
    featured: boolean;
    sponsored: boolean;
    primary_key: string;
    timestamp: number;
    date: string;
    event_type: string;
    keyword: string;
    carousel_position: string;
    trace: boolean;
    buttonType?: string;
    elementType?: string;
    recommended: boolean;
    experimentId?: string;
    variantId?: number;
}

// @ts-expect-error * Automated Type Error Fix
const formatDate = (timestamp) => {
    return new Date(parseInt(timestamp, 10)).toJSON();
};

export class AnalyticsService {
    eventTargets = [];
    // @ts-expect-error * Automated Type Error Fix
    googleTagManager: GoogleTagManager = null;
    constructor() {
        this.googleTagManager = new GoogleTagManager();
        // @ts-expect-error * Automated Type Error Fix
        this.eventTargets.push(new MarketingAnalytics(), this.googleTagManager, new CoveoAnalyticsTarget());
    }

    buildCurrentUrl() {
        const url = `${routerStore.getState().url}${
            routerStore.getState().queryString ? '?' + routerStore.getState().queryString : ''
        }`;
        return `${PUBLIC_URL}${url ? '/' + url : ''}`;
    }

    generateBaseAnalyticEvent() {
        const timestamp = Date.now();
        const date = formatDate(timestamp);
        return {
            viewport_height: Math.max(document.documentElement.clientHeight, window.innerHeight),
            viewport_width: Math.max(document.documentElement.clientWidth, window.innerWidth),
            device_height: window.screen.height,
            device_width: window.screen.width,
            browser: navigator.userAgent,
            language: window.navigator.language,
            url: this.buildCurrentUrl(),
            referrer: document.referrer,
            primary_key: uuidv4(),
            token: this.getUserToken(),
            timestamp: timestamp,
            date: date,
            channel: 'web',
            trace: false,
        } as AnalyticsEvent;
    }

    private getUserToken(): string {
        userStore.fetchUserToken();
        return selectUserToken(userStore.getState());
    }

    async sendEvent(event: AnalyticsEvent) {
        const postPromises = this.eventTargets.map(async (target) => {
            // @ts-expect-error * Automated Type Error Fix
            return target.postEvent(event);
        });

        const promisesStatus = await Promise.allSettled(postPromises);
        promisesStatus
            .filter((promise) => promise.status === 'rejected')
            .forEach((rejected: PromiseRejectedResult) => {
                logger.error(`Error posting analytics event: ${rejected.reason}`);
            });
    }

    async sendExperimentEvent(experimentId: string, variantId: number) {
        this.googleTagManager.sendExperiment(experimentId, variantId);
    }
}

export const isSponsoredSection = (type: string) => {
    return type === 'sponsored';
};

export const isRecommendedSection = (type: string) => {
    return type === 'recommended';
};
